module.exports = __webpack_public_path__ + "img/LeadImage.f288683a.png";